import { useQuery } from '@tanstack/react-query';
import { getContractUsersForEngineUpdate, mapContractUsersToEngineUpdateCandidates } from '../service';

export const engineUpdateCandidateUsersKey = ['ipa', 'setup', 'engine-update-notifications', 'candidate-users'] as const;

// Candidatos a destinatário: só usuários do contrato com acesso ao IPA (RN12, ver service.ts).
export const useEngineUpdateCandidateUsersQuery = () =>
  useQuery({
    queryKey: engineUpdateCandidateUsersKey,
    queryFn: async () => mapContractUsersToEngineUpdateCandidates(await getContractUsersForEngineUpdate()),
  });
